import React, { useEffect, useState } from "react";
import { useLocation, Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { toSlug, sortWeights } from "../utils/slugUtils";
import { useTranslation } from "react-i18next";
import "../styles/product-detail.css";

import bannerHenk from "../assets/images/bannerProductHenk.png";
import bannerMark from "../assets/images/bannerProductMarkandmilk.png";
import bannerMekong from "../assets/images/bannerProductMekongCocoa.png";
import bannerGanafarm from "../assets/images/bannerProductGanafarm.png";
import iconFacebook from "../assets/images/iconFacebook.png";
import iconInsta from "../assets/images/iconInstagram.png";
import iconGoogle from "../assets/images/iconGoogle.png";
import iconTiktok from "../assets/images/iconTiktok.png";
import RelatedProductsSlider from "../components/RelatedProductsSlider/RelatedProductsSlider";

import logoHenk from "../assets/images/logoHenkBlack.png";
import logoMark from "../assets/images/logoMarkandmilkWhite.png";
import logoMekong from "../assets/images/logoMekongcocoaYellow.png";
import logoGanafarm from "../assets/images/logoGanafarmBlack.png";
import bannerHenkMobile from "../assets/images/bannerProductHenkMobile.png";
import bannerMarkMobile from "../assets/images/bannerProductMarkandmilkMobile.png";
import bannerMekongMobile from "../assets/images/bannerProductMekongCocoaMobile.png";
import bannerGanafarmMobile from "../assets/images/bannerProductGanafarmMobile.png";
import bannerHenkTablet from "../assets/images/bannerProductHenkTablet.png";
import bannerMarkTablet from "../assets/images/bannerProductMarkandmilkTablet.png";
import bannerMekongTablet from "../assets/images/bannerProductMekongCocoaTablet.png";
import bannerGanafarmTablet from "../assets/images/bannerProductGanafarmTablet.png";

const bannerMap = {
  henk: bannerHenk,
  "mark-and-milk": bannerMark,
  "mekong-cocoa": bannerMekong,
  ganafarm: bannerGanafarm,
};
const bannerMapMobile = {
  henk: bannerHenkMobile,
  "mark-and-milk": bannerMarkMobile,
  "mekong-cocoa": bannerMekongMobile,
  ganafarm: bannerGanafarmMobile,
};
const bannerMapTablet = {
  henk: bannerHenkTablet,
  "mark-and-milk": bannerMarkTablet,
  "mekong-cocoa": bannerMekongTablet,
  ganafarm: bannerGanafarmTablet,
};

const bannerContentMap = {
  henk: {
    text: "desc_henk_detail",
    logo: logoHenk,
    classname: "henk-Product",
  },
  "mark-and-milk": {
    text: "desc_markandmilk_detail",
    logo: logoMark,
    classname: "markandmilk-Product",
  },
  "mekong-cocoa": {
    text: "desc_mekongcocoa_detail",
    logo: logoMekong,
    classname: "mekong-Product",
  },
  ganafarm: {
    text: "desc_ganafarm_detail",
    logo: logoGanafarm,
    classname: "ganafarm-Product",
  },
};

const ProductDetail = () => {
  const { t, i18n } = useTranslation(); // Thêm useTranslation
  const { id, slug } = useParams();
  const { state } = useLocation();
  const [product, setProduct] = useState(null);
  const [allProducts, setAllProducts] = useState([]);
  const [filteredRelatedProducts, setFilteredRelatedProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedWeight, setSelectedWeight] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isZoomed, setIsZoomed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 529);
  const [isTablet, setIsTablet] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 529);
      setIsTablet(window.innerWidth <= 767);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  let tenloaisp = 0;
  if (id === "henk") {
    tenloaisp = 1;
  } else if (id === "mekong-cocoa") {
    tenloaisp = 7;
  } else if (id === "ganafarm") {
    tenloaisp = 8;
  } else if (id === "mark-and-milk") {
    tenloaisp = 2;
  }

  useEffect(() => {
    // Cuộn lên đầu trang khi slug thay đổi
    window.scrollTo({ top: 0, behavior: "smooth" });

    const fetchProduct = async () => {
      try {
        const response = await fetch(
          `https://dht.api.mekongzone.com.vn/api/products/`,
          { credentials: "include" }
        );
        if (!response.ok) {
          if (response.status === 503) {
            throw new Error(
              "Máy chủ API tạm thời không khả dụng, vui lòng thử lại sau!"
            );
          }
          throw new Error(`Network response was not ok: ${response.status}`);
        }
        const data = await response.json();

        if (data && Array.isArray(data)) {
          const selectedProduct = data.find(
            (p) => toSlug(p.tensp, p.masp) === slug && p.maloaisp === tenloaisp
          );
          if (!selectedProduct) {
            console.error(`No product found for slug: ${slug}`);
            throw new Error(`Không tìm thấy sản phẩm với slug ${slug}.`);
          }

          // Gom nhóm các sản phẩm có cùng tensp và maloaisp
          const sameProducts = data.filter(
            (p) =>
              p.tensp === selectedProduct.tensp &&
              p.maloaisp === selectedProduct.maloaisp
          );
          // Tạo mảng các cặp { weight, image }
          const weightImagePairs = sameProducts
            .map((p) => ({
              weight:
                p.khoiluong && p.donViTinh
                  ? `${p.khoiluong}${p.donViTinh}`
                  : p.khoiluong,
              image: p.hinhanh,
            }))
            .filter((pair) => pair.weight && pair.image);
          // Sắp xếp theo weight
          const sortedPairs = sortWeights(
            weightImagePairs.map((pair) => pair.weight)
          ).map((weight) =>
            weightImagePairs.find((pair) => pair.weight === weight)
          );
          // Tách ra khoiluongKhac và hinhanhKhac
          const khoiluongKhac = [
            ...new Set(sortedPairs.map((pair) => pair.weight)),
          ].filter((w) => w !== undefined && w !== null);
          const hinhanhKhac = [
            ...new Set(sortedPairs.map((pair) => pair.image)),
          ].filter((img) => img !== undefined && img !== null);

          setProduct({
            ...selectedProduct,
            khoiluongKhac,
            hinhanhKhac,
          });
          setSelectedWeight(khoiluongKhac[0] || selectedProduct.khoiluong);
          setSelectedImage(hinhanhKhac[0] || selectedProduct.hinhanh);
        } else {
          throw new Error("Dữ liệu API không hợp lệ hoặc rỗng.");
        }
      } catch (err) {
        console.error("Fetch product error:", err.message);
        setError(err.message);
      }
    };

    const fetchAllProducts = async () => {
      try {
        const response = await fetch(
          `https://dht.api.mekongzone.com.vn/api/products`,
          { credentials: "include" }
        );
        if (!response.ok) {
          if (response.status === 503) {
            throw new Error(
              "Máy chủ API tạm thời không khả dụng, vui lòng thử lại sau!"
            );
          }
          throw new Error(`Network response was not ok: ${response.status}`);
        }
        const data = await response.json();
        if (data) {
          // Không gom nhóm, chỉ thêm khoiluong và slug
          const enhancedProducts = data.map((prod) => {
            const khoiluongWithUnit =
              prod.khoiluong && prod.donViTinh
                ? `${prod.khoiluong}${prod.donViTinh}`
                : prod.khoiluong || "Không xác định";
            return {
              ...prod,
              khoiluong: khoiluongWithUnit,
              slug: toSlug(prod.tensp, prod.masp),
            };
          });
          setAllProducts(enhancedProducts);
        }
      } catch (err) {
        console.error("Lỗi khi lấy tất cả sản phẩm:", err.message);
      }
    };

    fetchProduct().then(() => fetchAllProducts());
    setLoading(false);
  }, [id, slug, tenloaisp]);

  useEffect(() => {
    if (product && allProducts.length > 0) {
      const filteredProducts = allProducts
        .filter(
          (p) =>
            (p.maloaisp === product.maloaisp ||
              p.dongSanPham === product.dongSanPham) &&
            String(p.masp) !== String(product.masp)
        )
        .map((p) => {
          const khoiluongWithUnit =
            p.khoiluong && p.donViTinh
              ? `${p.khoiluong}`
              : p.khoiluong || "Không xác định";
          return { ...p, khoiluong: khoiluongWithUnit };
        })
        .sort((a, b) => {
          const weightA = parseFloat(a.khoiluong) || a.khoiluong;
          const weightB = parseFloat(b.khoiluong) || b.khoiluong;
          return weightA - weightB;
        });
      setFilteredRelatedProducts(filteredProducts);
    }
  }, [product, allProducts]);

  const handleWeightChange = (weight) => {
    setSelectedWeight(weight);
    const index = product.khoiluongKhac.indexOf(weight);
    if (index >= 0 && product.hinhanhKhac && product.hinhanhKhac[index]) {
      setSelectedImage(product.hinhanhKhac[index]);
    }
  };

  const handleImageChange = (image) => {
    setSelectedImage(image);
    const index = product.hinhanhKhac.indexOf(image);
    if (index >= 0 && product.khoiluongKhac && product.khoiluongKhac[index]) {
      setSelectedWeight(product.khoiluongKhac[index]);
    }
  };

  const handleZoom = () => {
    setIsZoomed(!isZoomed);
  };

  if (loading) return <div>Đang tải...</div>;
  if (error || !product)
    return (
      <div className="text-centers">
        {error || "Không tìm thấy thông tin sản phẩm."}
      </div>
    );

  // Ưu tiên file dịch, sản phẩm chưa có trong file dịch thì lấy từ database
  const tr = (key, dbValue) => {
    const fullKey = `${product.masp}.${key}`;
    return i18n.exists(fullKey) ? t(fullKey) : dbValue || "";
  };

  const parseMoTaChiTiet = () => {
    if (!product.motaphu) return [];
    const lines = tr("mo_ta", product.motaphu)
      .split(".")
      .map((line) => line.trim())
      .filter((line) => line.length > 0);
    return lines.length > 0 ? lines : [];
  };

  return (
    <div className="product-detail fade-in">
      <Helmet>
        <title>{`${product.tensp} | Gana Farm`}</title>
        <meta
          name="description"
          content={
            product.motaphu ||
            `Khám phá ${
              product.tensp
            } từ Gana Farm, sản phẩm chất lượng cao với các tùy chọn khối lượng: ${product.khoiluongKhac.join(
              ", "
            )}.`
          }
        />
      </Helmet>
      <section className="banner-section">
        {isMobile ? (
          <img
            src={bannerMapMobile[id] || bannerHenkMobile}
            alt=""
            className="banner_product"
          />
        ) : isTablet ? (
          <img
            src={bannerMapTablet[id] || bannerHenkTablet}
            alt=""
            className="banner_product"
          />
        ) : (
          <img
            src={bannerMap[id] || bannerHenk}
            alt=""
            className="banner_product"
          />
        )}
        {bannerContentMap[id] && (
          <div
            className={`banner-content ${bannerContentMap[id].classname} container`}
          >
            <img
              src={bannerContentMap[id].logo}
              alt={`${id} logo`}
              className="banner-logo"
            />
            <p className="banner-text">{t(bannerContentMap[id].text)}</p>
          </div>
        )}
      </section>
      <div className="product-detail__container container">
        <div className="product-detail__image">
          <div className="main-image-container">
            <img
              src={selectedImage || product.hinhanh || "/default-image.jpg"}
              alt={tr("ten_san_pham", product.tensp)}
              className={`main-image ${isZoomed ? "zoomed" : ""}`}
              onClick={handleZoom}
            />
          </div>
          {isZoomed && (
            <div className="zoom-overlay" onClick={handleZoom}>
              <img
                src={selectedImage || product.hinhanh || "/default-image.jpg"}
                alt={product.tensp}
                className="zoomed-image"
              />
            </div>
          )}
          {product.hinhanhKhac?.length > 1 && (
            <div className="product-detail__thumbnails">
              <div className="thumbnail-container">
                {product.hinhanhKhac.map((img, index) => (
                  <img
                    key={index}
                    src={img}
                    alt={`${product.tensp}-${index}`}
                    className={`thumbnail ${
                      selectedImage === img ? "active" : ""
                    }`}
                    onClick={() => handleImageChange(img)}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
        <div className="product-detail__info">
          <h1 className="product-detail__title">
            {tr("ten_san_pham", product.tensp)}
          </h1>

          <div>
            <strong>
              <p
                style={{ fontSize: "18px", marginBottom: "0px" }}
                className="brand-detail"
              >
                {t("detail_brand")}: {id.toUpperCase().replaceAll("-", " ")}
              </p>
            </strong>
            {product.khoiluongKhac?.length > 0 ? (
              <div className="product-detail__variants">
                <div className="d-flex gap-2 mt-2 product-detail__weight">
                  {product.khoiluongKhac.map((khoiluong, index) => (
                    <button
                      key={index}
                      className={`weight-btn ${
                        selectedWeight === khoiluong ? "active" : ""
                      }`}
                      onClick={() => handleWeightChange(khoiluong)}
                    >
                      {khoiluong}
                    </button>
                  ))}
                </div>
              </div>
            ) : (
              <span className="product-detail__variants">
                {product.khoiluong && product.donViTinh
                  ? `${product.khoiluong}${product.donViTinh}`
                  : product.khoiluong || "Không xác định"}
              </span>
            )}
          </div>
          <p className="product-detail__description">
            {tr("mo_ta", product.motaphu)}
          </p>

          <div className="d-flex contact__details">
            <Link to={`/lien-he`} className="btn booking__btn">
              <button className="btn contact__btn">
                {t("detail_contact")}
              </button>
            </Link>
            <div className="d-flex gap-2">
              <Link to={`/lien-he`}>
                <img src={iconGoogle} alt="Google" />
              </Link>
              <Link to={`/lien-he`}>
                <img src={iconTiktok} alt="TikTok" />
              </Link>
              <Link to={`/lien-he`}>
                <img src={iconInsta} alt="Instagram" />
              </Link>
              <Link
                to={`https://www.facebook.com/mekongzonechocolate`}
                target="_blank"
              >
                <img src={iconFacebook} alt="Facebook" />
              </Link>
            </div>
          </div>
        </div>
      </div>
      {product && (
        <div className="product-detail__specs mt-5 container">
          <h4>
            <strong>{t("detail_info_prod")}:</strong>
          </h4>
          {/* <ul className="px-0">
            {parseMoTaChiTiet().map((line, idx) => (
              <li key={idx}>- {line}</li>
            ))}
          </ul> */}

          <p>
            <strong>{t("detail_origin")}:</strong>{" "}
            {tr("xuat_xu", product.xuatXu) || "Không xác định"}
          </p>
          <p>
            <strong>{t("detail_date")}:</strong>{" "}
            {tr("han_su_dung", product.hanSuDung) || "Không xác định"}
          </p>
          <p>
            <strong>{t("detail_ingredients")}:</strong>{" "}
            {tr("thanh_phan", product.thanhPhan) || "Không xác định"}
          </p>
          <p>
            <strong>{t("detail_quality_standard")}:</strong>{" "}
            {tr("chi_tieu_chat_luong", product.chiTieuChatLuong) || "Không xác định"}
          </p>
          <p>
            <strong>{t("detail_direction")}:</strong>{" "}
            {tr("huong_dan_su_dung", product.huongDanSuDung) || "Không xác định"}
          </p>
          <p>
            <strong>{t("detail_storage")}:</strong>{" "}
            {tr("bao_quan", product.baoQuan) || "Không xác định"}
          </p>
        </div>
      )}
      <RelatedProductsSlider relatedProducts={filteredRelatedProducts} />
      <div className="contact-info container"></div>
    </div>
  );
};

export default ProductDetail;
